import { createComponent } from '@carvana/merch-components';
import React, { forwardRef } from 'react';

type OwnProps = React.PropsWithoutRef<React.SVGProps<SVGSVGElement>> & {
  isFavorited?: boolean;
};

const Heart = createComponent<OwnProps>('svg', {
  className: '-:text-blue-6'
});

export default forwardRef<SVGSVGElement, OwnProps>(({ ...props }, ref) => (
  <Heart
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    ref={ref}
    {...props}
  >
    <path
      className="fill-none"
      d="M2.07514 3.06558L2.07529 3.06543C2.77436 2.37849 3.7014 2 4.69925 2C5.68637 2 6.60802 2.37259 7.30268 3.04694L7.99821 3.72213L8.69472 3.04795C10.1421 1.64694 12.4876 1.65297 13.924 3.06453L13.9242 3.0647C15.3552 4.47031 15.3584 6.74865 13.9347 8.15738L7.99439 13.6389L2.06512 8.15962C0.641323 6.74876 0.645274 4.47003 2.07514 3.06558Z"
      stroke="currentColor"
      strokeWidth="2"
    />
  </Heart>
));
